// extracted by mini-css-extract-plugin
module.exports = {"container":"WordCloud_container__22rsu","cardContainer":"WordCloud_cardContainer__3RIlY","cardContainerModal":"WordCloud_cardContainerModal__3j-F5"};